/**
 * @generated SignedSource<<145817c438960708f057be3665812e7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewPresentationSeparator_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationSeparator",
  "abstractKey": null
};

node.hash = "b50efb052aeafc3d3b518892b6dbe0e6";

module.exports = node;
